module.exports = __webpack_public_path__ + "static/media/Jake Mix.98033eec.png";